// A controlled list, with the one legitimate escape hatch: adding an entry explicitly.
//
// Typing a value that is not in the list is not expressible here, which is the UI half of business
// rule 3. The API enforces the other half - a select is a convenience, not a control.
//
// Adding an entry is a reference-data write, which is OPERATIONS' alone (ADR-0012), so the caller
// says whether to offer it with `canAdd`.

import { useState } from 'react';

import Icon from '../../ui/Icon.jsx';
import AddEntryDialog from './AddEntryDialog.jsx';

export default function ListSelect({
  label, listName, entries, value, onChange, error, onAdded, canAdd = false, flag = null,
}) {
  const [adding, setAdding] = useState(false);

  return (
    <label className="field list-select">
      <span className="field-label">{label}{flag}</span>
      <span className="field-control">
        <select value={value ?? ''} onChange={(event) => onChange(event.target.value)}>
          <option value="">—</option>
          {entries.map((entry) => (
            <option key={entry.code} value={entry.code}>{entry.label}</option>
          ))}
        </select>
        {/* Named per list rather than identical "Add new" buttons on one form. */}
        {canAdd && (
          <button type="button" className="icon-button quiet" onClick={() => setAdding(true)}
                  aria-label={`Add new ${label.toLowerCase()}`}
                  title={`Add new ${label.toLowerCase()}`}>
            <Icon name="plus" />
          </button>
        )}
      </span>
      {error && <span className="field-error">{error}</span>}

      {adding && (
        <AddEntryDialog
          listName={listName}
          label={label}
          onClose={() => setAdding(false)}
          onAdded={(entry) => {
            setAdding(false);
            onAdded();
            // Select what was just added: it was added in order to be used here.
            onChange(entry.code);
          }}
        />
      )}
    </label>
  );
}
